import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import PropTypes from "prop-types";

function VisualizarCobrancaModal({ visualizarModalHook, documento }) {
  const { visualizarDocumentoModal, setVisualizarDocumentoModal } =
    visualizarModalHook;

  return (
    <CommonModal
      title="Visualizar documento"
      is_open_modal={visualizarDocumentoModal}
      set_is_open_modal={setVisualizarDocumentoModal}
      size="xl"
    >
      <div className="visualizar_documento">
        <embed src={documento} frameBorder="0" width="100%" height="480px" />
      </div>
    </CommonModal>
  );
}

VisualizarCobrancaModal.propTypes = {
  visualizarModalHook: PropTypes.shape({
    visualizarDocumentoModal: PropTypes.bool.isRequired,
    setVisualizarDocumentoModal: PropTypes.func.isRequired,
  }).isRequired,
  documento: PropTypes.string.isRequired,
};

export default VisualizarCobrancaModal;
